import React from "react";
import { Grid, styled } from "@mui/material/";

const useStyles = styled({
  img_data: {
    margin: "auto",
    height: "40%",
  },
});

export default function SearchingComponent() {
  const classes = useStyles();
  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      xl={12}
      sx={{ display: "flex", justifyContent: "center" }}
    >
      <img
        src={require("../../assets/gif/search.gif")}
        className={classes.img_data}
        alt='noreult'
      />
    </Grid>
  );
}
